module.exports = __webpack_public_path__ + "assets/img/3da6d72c077e09502f55defb86f1224e.png";